import { HTTP } from 'providers'

export class UserRoleService extends HTTP {
  private endpoint = '/user-role'

  public fetchAll() {
    return this.get({ endpoint: this.endpoint })
  }
}
